export const INTERNAL_REQUISITION_STATUS_DRAFT = 0;
export const INTERNAL_REQUISITION_STATUS_JUST_PLACED = 1;
export const INTERNAL_REQUISITION_STATUS_APPROVED = 2;
export const INTERNAL_REQUISITION_STATUS_CANCELLED = 3;

export const INTERNAL_REQUISITION_STATUS_NAME = {
    0: 'Draft',
    1: 'Just Placed',
    2: 'Approved',
    3: 'Cancelled',
};
export const INTERNAL_REQUISITION_STATUS_DROPDOWN_OPTIONS = [
    { value: INTERNAL_REQUISITION_STATUS_DRAFT, label: INTERNAL_REQUISITION_STATUS_NAME[INTERNAL_REQUISITION_STATUS_DRAFT] },
    { value: INTERNAL_REQUISITION_STATUS_JUST_PLACED, label: INTERNAL_REQUISITION_STATUS_NAME[INTERNAL_REQUISITION_STATUS_JUST_PLACED] },
    { value: INTERNAL_REQUISITION_STATUS_APPROVED, label: INTERNAL_REQUISITION_STATUS_NAME[INTERNAL_REQUISITION_STATUS_APPROVED] },
    { value: INTERNAL_REQUISITION_STATUS_CANCELLED, label: INTERNAL_REQUISITION_STATUS_NAME[INTERNAL_REQUISITION_STATUS_CANCELLED] },
];

export const INTERNAL_REQUISITION_PROCUREMENT_TYPE_LOCAL = 1;
export const INTERNAL_REQUISITION_PROCUREMENT_TYPE_FOREIGN = 2;

export const INTERNAL_REQUISITION_PROCUREMENT_TYPE_NAME = {
    [INTERNAL_REQUISITION_PROCUREMENT_TYPE_LOCAL]: 'Local',
    [INTERNAL_REQUISITION_PROCUREMENT_TYPE_FOREIGN]: 'Foreign',
};

export const INTERNAL_REQUISITION_PROCUREMENT_TYPE_DROPDOWN_OPTIONS = [
    {
        value: INTERNAL_REQUISITION_PROCUREMENT_TYPE_LOCAL,
        label: INTERNAL_REQUISITION_PROCUREMENT_TYPE_NAME[INTERNAL_REQUISITION_PROCUREMENT_TYPE_LOCAL]
    },
    {
        value: INTERNAL_REQUISITION_PROCUREMENT_TYPE_FOREIGN,
        label: INTERNAL_REQUISITION_PROCUREMENT_TYPE_NAME[INTERNAL_REQUISITION_PROCUREMENT_TYPE_FOREIGN]
    },
];

export const INTERNAL_REQUISITION_PRIORITY_OPTIONS = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'urgent', label: 'Urgent' },
];

export const INTERNAL_REQUISITION_PRIORITY_NAME = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent',
};

export const InternalRequisitionModel = {
    code: 'Auto Generated',
    branch_id: 0,
    branch: { name: '' },
    department_id: 0,
    department: { name: '' },
    project_id: 0,
    project: { name: '' },
    procurement_type: 0,
    status: INTERNAL_REQUISITION_STATUS_DRAFT,
    approval_channel: [],
    approval_status: 0,
    approval_status_name: 'Pending',
    submitted_at: '',
    approval_completed_at: '',
    current_approval_step_id: null,
    current_approval_step: null,
    approval_steps: [],
    current_approval_user_id: null,
    current_approval_user: null,
    pending_action_type: 'approval',
    pending_comment_user_id: null,
    pending_comment_user: null,
    pending_comment_requested_by_id: null,
    pending_comment_requested_by: null,
    pending_comments: '',
    comment_history: [],
    comment_timeline: [],
    can_act: false,
    can_approve: false,
    can_request_comment: false,
    can_change_approval_channel: false,
    can_comment: false,
    current_action_type: 'approval',
    approved_at: '',
    approved_by_id: null,
    approved_by: { name: '' },
    // cancelled_at: '',
    // cancelled_by_id: null,
    // cancelled_by: { name: '' },
    created_by_id: 0,
    created_by: { name: '' },
    created_at: '',
    updated_by_id: 0,
    updated_by: { name: '' },
    updated_at: '',
    internal_requisition_details: [],
}
